import { FontSize } from "@/components/tiptap/TextStyle.tsx";
import { Label } from "@/components/ui/label.tsx";
import { Link } from "@tiptap/extension-link";
import Paragraph from "@tiptap/extension-paragraph";
import { TextAlign } from "@tiptap/extension-text-align";
import { TextStyle } from "@tiptap/extension-text-style";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { useEffect } from "react";
import { CustomHeading } from "./CustmHeading";
import { Indent } from "./Indent";
import ToolBar from "./ToolBar";
import React from "react";
import { cn } from "@/lib/utils";

const CustomParagraph = Paragraph.extend({
  addAttributes() {
    return {
      class: {
        default: "spacing-paragraph-4",
        renderHTML: (attributes) => {
          return {
            class: `${attributes.class}`,
          };
        },
      },
    };
  },
});

const Tiptap = React.forwardRef<
  HTMLDivElement,
  {
    description: string;
    label: string;
    onChange: (richText: string) => void;
    disabled?: boolean;
  } & React.HTMLProps<HTMLDivElement>
>(
  (
    { description, onChange, label, disabled = false, className, ...props },
    ref,
  ) => {
    const editor = useEditor({
      extensions: [
        StarterKit.configure({
          paragraph: false,
          heading: false,
        }),
        Indent,
        FontSize.configure({
          types: ["paragraph"],
          fontSize: ["12px", "14px", "16px", "18px", "20px"],
          defaultFontSize: "16px",
        }),
        TextStyle,
        TextAlign.configure({
          types: ["heading", "paragraph"],
        }),
        Link.configure({
          openOnClick: false,
          HTMLAttributes: {
            target: "_blank",
            rel: "noopener noreferrer",
          },
        }),
        CustomHeading.configure({
          levels: [2, 3],
        }),
        CustomParagraph,
      ],
      content: "",
      editable: !disabled,

      editorProps: {
        attributes: {
          class:
            "rounded-md border min-w-[50%] bg-white text-black min-h-[150px] font-['Instrument Sans'] border-input bg-background focus:ring-offset-2 p-2",
        },
      },
      onUpdate({ editor }) {
        onChange(editor.getHTML());
      },
    });

    useEffect(() => {
      if (editor) {
        if (description !== editor.getHTML()) {
          editor.commands.setContent(description, false);
        }
      }
    }, [editor, description]);

    return (
      <div
        className={
          (cn(
            `flex w-full flex-col justify-stretch  text-start antialiased ${disabled ? "cursor-not-allowed" : "min-h-[250px]"}`,
          ),
          className)
        }
        ref={ref}
        {...props}
      >
        {label && (
          <Label
            className={`flex text-start text-slate-700 text-sm font-medium font-['Raleway'] leading-normal ${disabled ? "mb-2" : ""}`}
          >
            {label}
          </Label>
        )}
        {!disabled && (
          <div className="sticky top-0  z-10">
            <ToolBar editor={editor} />
          </div>
        )}
        <EditorContent
          editor={editor}
          disabled={disabled}
          className={`${disabled ? "opacity-50 " : ""}`}
        />
      </div>
    );
  },
);

export default Tiptap;
